// IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка пузиря групами, з кольорами категорій)
// Alt-подсказка пузыря вкладки Heatmap (AttrHeatmap.vue) — разметка по группам вместо одной строки текста:
//   шапка (строка, группа строк, период ячейки) → «<мера>» (значение, «N of M (x %)», доля от max строки, число строк источника) →
//   «By source» / «Category» (сектора пузыря: цветная метка того же цвета, что сектор и чип легенды, название, значение, процент; по убыванию,
//   нулевые не показываются) → «Users» (при текущей мере Users: кто менял — лениво из деталей ячейки, до 8 имён и строка-кнопка «More (N)») →
//   «Other measures» (значения остальных мер ячейки из строк источника; нет данных — группы нет).
// Чистые функции (без Vue и DOM): модель собирает компонент, здесь — сортировки, срезы и HTML. Все данные экранируются, разметка — только свои теги.
// Выключатель fe.ux.heatmapTipGroups (по умолчанию ВКЛ): ВЫКЛ — прежний текст одной строкой (AttrHeatmap.cellReadout)
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): «Users» — из сводки бэка (heatmap_cell, summary 'users': все пользователи ячейки
// без среза 500 последних изменений); ошибка / стенд без DS сводки — прежний путь (детали ячейки + группировка здесь). Строка «Rows» группы меры — только у меры rows
import { t as tI18n, tn as tnI18n } from '@/i18n'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): tn — «{n} records» у пользователя

export const HEATMAP_TIP_GROUPS_FLAG = 'fe.ux.heatmapTipGroups'
export function heatmapTipGroups_on(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(HEATMAP_TIP_GROUPS_FLAG, true) !== false : true } catch (e) { return true }
}

export const HEATMAP_TIP_USERS_MAX = 8   // имён до кнопки «More (N)»
export const HEATMAP_TIP_USERS_MEASURE = 'users'   // мера «Users» по умолчанию (hm_users_measure)
export const HEATMAP_TIP_USERS_FIELD = 'updated_by'   // поле пользователя в строках деталей ячейки (hm_users_field); подпись — <поле>_title, если есть
export const HEATMAP_TIP_USERS_SUMMARY = 'users'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): params.summary запроса heatmap_cell

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const numOrNull = (v) => { if (v === null || v === undefined || str(v) === '') return null; const n = Number(v); return Number.isFinite(n) ? n : null }

export function hmTip_esc(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}
// цвет метки — только безопасные формы (#hex, hsl(), rgb()); иное — метки нет
const RE_COLOR = /^(#[0-9a-f]{3,8}|(hsl|hsla|rgb|rgba)\(\s*[\d.,%\s]+\))$/i
export function hmTip_color(c) { const s = str(c); return RE_COLOR.test(s) ? s : '' }

// процент доли: целые, больше нуля и меньше 0.5 % — '<1%'
function sharePct(x) {
    const p = Number(x) * 100
    if (!(p > 0)) return '0%'
    return p < 0.5 ? '<1%' : `${Math.round(p)}%`
}

// сектора пузыря: cell.cats ([{ key, value, n, share }], heatmap_cell_cats) → [{ key, title, color, value, pct }] по убыванию значения (равенство — по числу строк,
// затем по подписи); категории с нулевым / пустым значением не показываются. titleOf / colorOf — подпись и цвет категории (как у легенды)
export function heatmap_tip_sectors(cats, titleOf, colorOf) {
    const tt = typeof titleOf === 'function' ? titleOf : (k) => k
    const cc = typeof colorOf === 'function' ? colorOf : () => ''
    const list = (Array.isArray(cats) ? cats : []).filter(c => c && Number(c.value) > 0)
    const tot = list.reduce((s, c) => s + Number(c.value), 0)
    return list.map(c => ({ key: c.key, title: str(tt(c.key)) || str(c.key), color: hmTip_color(cc(c.key)), value: Number(c.value), n: Number(c.n) || 0,
        pct: sharePct(tot > 0 ? Number(c.value) / tot : 0) }))
        .sort((a, b) => b.value - a.value || b.n - a.n || (a.title < b.title ? -1 : (a.title > b.title ? 1 : 0)))
}

// значения остальных мер ячейки из строк источника (rows[idx]): measures — [{ binding, title }], current — текущая мера (не повторяется), aggOf(binding) — 'sum' | 'max'.
// Мера, у которой ни в одной строке ячейки нет числа, пропускается; нет ни одной — []
export function heatmap_tip_measures(rows, idx, measures, current, aggOf) {
    const R = Array.isArray(rows) ? rows : []
    const out = []
    for (const m of (Array.isArray(measures) ? measures : [])) {
        const b = str(m && m.binding)
        if (!b || b === str(current)) continue
        const isMax = typeof aggOf === 'function' && aggOf(b) === 'max'
        let v = null
        for (const i of (Array.isArray(idx) ? idx : [])) {
            const x = numOrNull(R[i] && R[i][b])
            if (x === null) continue
            v = v === null ? x : (isMax ? Math.max(v, x) : v + x)
        }
        if (v !== null) out.push({ binding: b, title: str(m.title) || b, value: v })
    }
    return out
}

// пользователи ячейки из строк деталей (heatmap_cell): группировка по полю field (подпись — <field>_title, иначе значение), число изменений (строк) на пользователя,
// категория — самая частая у него (catField, напр. actor_kind). По убыванию числа, равенство — по подписи. Поля field нет ни в одной строке — null (группы нет)
export function heatmap_tip_users(detailRows, field = HEATMAP_TIP_USERS_FIELD, catField = '') {
    const R = (Array.isArray(detailRows) ? detailRows : []).filter(r => r && typeof r === 'object')
    const f = str(field) || HEATMAP_TIP_USERS_FIELD
    if (!R.some(r => Object.prototype.hasOwnProperty.call(r, f))) return null
    const tf = `${f}_title`, cf = str(catField)
    const map = new Map()
    for (const r of R) {
        const key = str(r[f])
        if (!key) continue
        const u = map.get(key) || { key, title: '', n: 0, cats: new Map() }
        if (!u.title) u.title = str(r[tf])
        u.n += 1
        if (cf) { const c = str(r[cf]); if (c) u.cats.set(c, (u.cats.get(c) || 0) + 1) }
        map.set(key, u)
    }
    return [...map.values()].map(u => {
        let cat = '', best = 0
        for (const [c, k] of u.cats) if (k > best) { cat = c; best = k }
        return { key: u.key, title: u.title || u.key, n: u.n, cat }
    }).sort((a, b) => b.n - a.n || (a.title < b.title ? -1 : (a.title > b.title ? 1 : 0)))
}

// IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду)
// сводка бэка по пользователям ячейки (ответ heatmap_cell с summary 'users'): rows [{ updated_by, updated_by_title, changes, records, last_at, actor_kind }]
// по убыванию changes (≤ 200), users_total — всего пользователей ячейки, partial — журнал прочитан не весь. Не сводка (нет summary 'users' / rows) или ошибка — null
// (вызывающий откатывается на детали). Пустой updated_by — строка «без пользователя» (title ''; подпись даёт разметка). Порядок — как у бэка
export function heatmap_tip_users_summary(hc) {
    if (!hc || typeof hc !== 'object' || hc.error || str(hc.summary) !== HEATMAP_TIP_USERS_SUMMARY || !Array.isArray(hc.rows)) return null
    const list = hc.rows.filter(r => r && typeof r === 'object').map(r => {
        const key = str(r.updated_by)
        return { key, title: key ? (str(r.updated_by_title) || key) : '', n: numOrNull(r.changes) ?? 0, records: numOrNull(r.records), cat: str(r.actor_kind) }
    })
    const ut = numOrNull(hc.users_total)
    return { list, total: ut !== null && ut >= list.length ? ut : list.length, shown: list.length, partial: hc.partial === true }
}

// IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду)
// разбор ответа heatmap_cell для группы «Users»: state 'ok' | 'error' (ошибка запроса / нет ответа), hc — answer.heatmap_cell, mode 'summary' | 'details'.
// Ответ: { fallback: true, sticky } — сводки нет, перезапросить детали (sticky — ошибка бэка, напр. «not a data source» на стенде без пересева: дальше сразу детали);
// иначе { entry: { state: 'ok' | 'none' | 'error', mode, list, total, shown, partial } } — запись кэша ячейки. field / catField — поле пользователя и категории у деталей
export function heatmap_tip_users_answer(state, hc, mode, field = HEATMAP_TIP_USERS_FIELD, catField = '') {
    if (mode === 'summary') {
        const s = state === 'ok' ? heatmap_tip_users_summary(hc) : null
        if (!s) return { fallback: true, sticky: state === 'ok' || !!(hc && hc.error) }
        return { entry: { state: s.list.length ? 'ok' : 'none', mode: 'summary', list: s.list, total: s.total, shown: s.shown, partial: s.partial } }
    }
    if (state !== 'ok' || !hc) return { entry: { state: 'error', mode: 'details', list: [], total: 0, shown: 0, partial: false } }
    const rows = Array.isArray(hc.rows) ? hc.rows : []
    const list = heatmap_tip_users(rows, field, catField)
    const tot = numOrNull(hc.total)
    return { entry: { state: list === null ? 'none' : 'ok', mode: 'details', list: list || [], total: tot !== null ? tot : rows.length, shown: rows.length, partial: false } }
}

// срез списка: свёрнут — первые max и остаток more; развёрнут — все.
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): total — всего пользователей (users_total сводки; больше длины списка — «More (N)» считает от него)
export function heatmap_tip_slice(list, expanded, max = HEATMAP_TIP_USERS_MAX, total = null) {
    const L = Array.isArray(list) ? list : []
    const k = Math.max(1, Number(max) || HEATMAP_TIP_USERS_MAX)
    if (expanded || L.length <= k) return { items: L, more: 0 }
    const all = Number.isFinite(Number(total)) && total !== null && Number(total) > L.length ? Number(total) : L.length   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду)
    return { items: L.slice(0, k), more: all - k }
}

// ---- разметка ----
const kv = (k, v, sw, cls) => `<span class="hm-tip-k${cls ? ' ' + cls : ''}">${sw ? `<i class="hm-tip-sw" style="background:${sw}"></i>` : ''}<span class="hm-tip-kt">${hmTip_esc(k)}</span></span>`
    + `<span class="hm-tip-v${cls ? ' ' + cls : ''}">${hmTip_esc(v)}</span>`
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): строка пользователя сводки — значение (изменения) и мелкая приписка (записи)
const kvUser = (k, v, small, sw) => `<span class="hm-tip-k">${sw ? `<i class="hm-tip-sw" style="background:${sw}"></i>` : ''}<span class="hm-tip-kt">${hmTip_esc(k)}</span></span>`
    + `<span class="hm-tip-v">${hmTip_esc(v)}${small ? `<span class="hm-tip-vs">${hmTip_esc(small)}</span>` : ''}</span>`
const sec = (cap, body) => `<div class="hm-tip-sec"><div class="hm-tip-cap">${hmTip_esc(cap)}</div>${body}</div>`

// model: {
//   head: { title, group, period },
//   measure: { title, binding, value, of: { m, p } | null, max: { value, p } | null, rows },   (rows — строка «Rows» только у меры binding 'rows')
//   sectors: { title, items: heatmap_tip_sectors(...) } | null,
//   users: { title, state: 'loading' | 'ok' | 'error', mode: 'summary' | 'details', items, more, count, total, shown, partial, moreKey, colorOf } | null,
//   others: [{ title, value }] | null
// }
// opts: { t, tn, fmt } — перевод (английская база с {var}), множественное число и формат числа
export function heatmap_tip_html(model, opts = {}) {
    const t = typeof opts.t === 'function' ? opts.t : tI18n
    const tn = typeof opts.tn === 'function' ? opts.tn : tnI18n   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду)
    const fmt = typeof opts.fmt === 'function' ? opts.fmt : (v) => String(v ?? '')
    const M = model && typeof model === 'object' ? model : {}
    const parts = []
    const H = M.head || {}
    const sub = [str(H.group), str(H.period)].filter(Boolean).map(hmTip_esc).join(' · ')
    parts.push(`<div class="hm-tip-head"><div class="hm-tip-title">${hmTip_esc(H.title)}</div>${sub ? `<div class="hm-tip-sub">${sub}</div>` : ''}</div>`)
    const ms = M.measure
    if (ms) {
        let body = kv(t('Value'), ms.of && ms.of.p ? t('{n} of {m} ({p})', { n: fmt(ms.value), m: fmt(ms.of.m), p: ms.of.p }) : fmt(ms.value))
        if (ms.max && ms.max.value !== null && ms.max.value !== undefined) body += kv(t('Row max'), ms.max.p ? `${fmt(ms.max.value)} · ${ms.max.p}` : fmt(ms.max.value))
        if (ms.rows !== null && ms.rows !== undefined && str(ms.binding) === 'rows') body += kv(t('Rows'), fmt(ms.rows))   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): «Rows» — не бизнесовая строка, только у меры rows
        parts.push(sec(ms.title, body))
    }
    const S = M.sectors
    if (S && Array.isArray(S.items) && S.items.length) {
        parts.push(sec(S.title, S.items.map(c => kv(c.title, `${fmt(c.value)} · ${c.pct}`, c.color)).join('')))
    }
    const U = M.users
    if (U) {
        let body = ''
        if (U.state === 'loading') body = `<span class="hm-tip-note">${hmTip_esc(t('Loading users…'))}</span>`
        else if (U.state === 'error') body = kv(t('Users'), fmt(U.count))
        else {
            const cof = typeof U.colorOf === 'function' ? U.colorOf : () => ''
            if (U.mode === 'summary') {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду): сводка — пустой пользователь «(no user)», изменения справа и записи мельче
                body = (U.items || []).map(u => kvUser(u.title || t('(no user)'), fmt(u.n),
                    u.records !== null && u.records !== undefined ? tn(u.records, '{n} record', '{n} records', { n: fmt(u.records) }) : '', hmTip_color(u.cat ? cof(u.cat) : ''))).join('')
            } else body = (U.items || []).map(u => kv(u.title, fmt(u.n), hmTip_color(u.cat ? cof(u.cat) : ''))).join('')
            if (U.more > 0) body += `<button type="button" tabindex="-1" class="hm-tip-more" data-hm-tip-more="${hmTip_esc(U.moreKey)}">${hmTip_esc(t('More ({n})', { n: U.more }))}</button>`
            if (U.mode === 'summary') {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: користувачі у підказці пузиря — зведення з бекенду)
                if (U.total > U.shown) body += `<span class="hm-tip-note">${hmTip_esc(t('Shown {n} of {m}', { n: fmt(U.shown), m: fmt(U.total) }))}</span>`
                if (U.partial) body += `<span class="hm-tip-note">${hmTip_esc(t('By the last changes only'))}</span>`
            } else if (U.total > U.shown) body += `<span class="hm-tip-note">${hmTip_esc(t('By the last {n} changes', { n: fmt(U.shown) }))}</span>`
        }
        parts.push(sec(U.title || t('Users'), body))
    }
    const O = M.others
    if (Array.isArray(O) && O.length) parts.push(sec(t('Other measures'), O.map(o => kv(o.title, fmt(o.value))).join('')))
    return `<div class="hm-tip hm-tip-g">${parts.join('')}</div>`
}

// заголовок группы секторов (английская база для t()): hm_category_title вкладки; иначе все категории — «кто менял» (actorKeys) — 'By source', прочие — 'Category'
export function heatmap_tip_cat_caption(vpTitle, keys, actorKeys) {
    if (str(vpTitle)) return str(vpTitle)
    const A = actorKeys && typeof actorKeys === 'object' ? actorKeys : {}
    const K = (Array.isArray(keys) ? keys : []).filter(k => str(k))
    return K.length && K.every(k => Object.prototype.hasOwnProperty.call(A, k)) ? 'By source' : 'Category'
}

// ==== IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню) ====
// 1. Alt-подсказка пузыря доживает после отпускания Alt, как у чатов и шапки грида (общий контроллер utils/altTooltip.js: пауза fe.data.altTooltipLingerGraceMs,
//    затухание fe.data.altTooltipFadeMs, класс .alt-tip-fading): раньше источник «по точке» матрицы отдавал noLinger — отпустил Alt, подсказка исчезла.
//    Дожитие держится, пока курсор на САМОМ пузыре или на подсказке (lingerEl — кнопка ячейки, а не вся область прокрутки: иначе любое место матрицы
//    держало бы подсказку чужого пузыря). Выключатель fe.ux.heatmapTipLinger (по умолчанию ВКЛ; ВЫКЛ — прежнее noLinger)
export const HEATMAP_TIP_LINGER_FLAG = 'fe.ux.heatmapTipLinger'
export function heatmapTipLinger_on(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(HEATMAP_TIP_LINGER_FLAG, true) !== false : true } catch (e) { return true }
}
// ответ источника «по точке» (контракт altTooltip.resolveAt): с дожитием — lingerEl пузыря, без него — noLinger
export function heatmap_tip_at(content, rect, lingerEl, linger) {
    if (!content) return null
    return linger && lingerEl ? { content, rect, lingerEl } : { content, rect, noLinger: true }
}
// 2. Подпись, обрезанная многоточием (подписи строк и групп, узлы шапки, подписи колонок), — по наведению её «продолжение» поверх (utils/clipOverlay.js),
//    как у заголовков и ячеек AttrGrid, строк форм чипсов и панели-меню; не обрезанная — ничего. Выключатель fe.ux.heatmapClipTail (по умолчанию ВКЛ)
export const HEATMAP_CLIP_FLAG = 'fe.ux.heatmapClipTail'
export function heatmapClip_on(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(HEATMAP_CLIP_FLAG, true) !== false : true } catch (e) { return true }
}
export const HEATMAP_CLIP_SEL = '.hm-band, .hm-ylabel, .hm-group-title, .hm-xlabel, .hm-extra-head, .hm-extra'
// обрезан ли текст по замерам элемента: { text, overflowX, overflowY, whiteSpace, scrollWidth, clientWidth, scrollHeight, clientHeight, textWidth, innerWidth }.
// Правила — как clipTail_cut панели-меню: по ширине / высоте при overflow hidden | clip; у nowrap — ещё и на долю пикселя (ширина текста Range'ем против внутренней ширины)
export function heatmap_clip_cut(m) {
    if (!m || !str(m.text)) return false
    const hx = /hidden|clip/.test(m.overflowX || ''), hy = /hidden|clip/.test(m.overflowY || '')
    if (hx && +m.scrollWidth > +m.clientWidth + 1) return true
    if (hy && +m.scrollHeight > +m.clientHeight + 1) return true
    if (!hx || !/nowrap|pre/.test(m.whiteSpace || '')) return false
    const tw = numOrNull(m.textWidth), iw = numOrNull(m.innerWidth)
    return tw !== null && iw !== null && tw > iw + 0.5
}
